import { render, staticRenderFns } from "./Facturations.vue?vue&type=template&id=311296eb&scoped=true"
import script from "./Facturations.vue?vue&type=script&lang=js"
export * from "./Facturations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311296eb",
  null
  
)

export default component.exports